import { UpdateApprovalFlowDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import type { ApprovalFlowArgs } from 'modules/approvals/lib/approvalFlows'

export const useUpdateApprovalFlow = () => {
  const [update, { loading }] = useMutation(UpdateApprovalFlowDocument, {
    extractorFn: (data) => data.approvalsMutations.updateApprovalsApprovalFlow,
  })

  return {
    loading,
    updateApprovalFlow(id: number, data: ApprovalFlowArgs) {
      return update({
        variables: {
          ...data,
          id,
        },
      })
    },
  }
}
